import { Component, inject, Input, Signal } from '@angular/core';
import {
  ApplicationAppEntityApplicationRead,
  TaxObjectAppEntityApplicationRead,
  TaxObjectAppEntityTaxObjectWrite
} from '../../../../../../openapi';
import { LabelComponent } from '../../../../../../common/label/label.component';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { selectApplication } from '../../../../../../store/selectors/application.selectors';
import {
  AdditionalLocationDescriptionLabelPipe
} from '../../../../../../pipes/additional-location-description-label.pipe';
import { HasLandRegisterLabelPipe } from '../../../../../../pipes/has-land-register-label.pipe';
import { CanDisplayPipe } from '../../../../../../pipes/can-display.pipe';

@Component({
  selector: 'app-tax-object-item-preview',
  standalone: true,
  imports: [
    LabelComponent,
    DatePipe,
    AdditionalLocationDescriptionLabelPipe,
    HasLandRegisterLabelPipe,
    CanDisplayPipe,
    DecimalPipe
  ],
  templateUrl: './tax-object-item-preview.component.html'
})
export class TaxObjectItemPreviewComponent {
  @Input()
  public taxObject: TaxObjectAppEntityTaxObjectWrite | TaxObjectAppEntityApplicationRead | undefined;

  private store$: Store = inject(Store);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);
}
